import { type ReactNode } from 'react';
import type { Creator } from '@/types';
import {
  useHardDeleteCreator,
  useRestoreCreator,
} from '../hooks/use-creator-mutations';
import { CreatorRestoreConfirm } from './creator-restore-confirm';
import { CreatorHardDeleteConfirm } from './creator-hard-delete-confirm';
import type { DetailMode } from './creator-detail-sections';

type SectionProps = {
  creator: Creator;
  setMode: (m: DetailMode) => void;
  onClose: () => void;
};

export function RestoreSection({
  creator,
  setMode,
  onClose,
}: SectionProps): ReactNode {
  const restore = useRestoreCreator();
  return (
    <div className="mt-base">
      <CreatorRestoreConfirm
        onConfirm={() => restore.mutate(creator.id, { onSuccess: onClose })}
        onCancel={() => setMode('view')}
        isPending={restore.isPending}
      />
    </div>
  );
}

export function HardDeleteSection({
  creator,
  setMode,
  onClose,
}: SectionProps): ReactNode {
  const hard = useHardDeleteCreator();
  return (
    <div className="mt-base">
      <CreatorHardDeleteConfirm
        onConfirm={() => hard.mutate(creator.id, { onSuccess: onClose })}
        onCancel={() => setMode('view')}
        isPending={hard.isPending}
      />
    </div>
  );
}
